module.exports = __webpack_public_path__ + "static/media/adiposidad_localizada.4633900c.jpg";